import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import Collapse from 'src/shared/components/collapse';
import { TagInput } from './tagInput';
import { TagList } from './tagList';
export function Tags() {
    const form = useFormContext();
    const { t } = useTranslation();
    return (_jsxs(Collapse, { startOpen: form.watch('tags').length > 0, children: [_jsx(Collapse.Header, { children: t('content.form.search_tags.title') }), _jsxs(Collapse.Body, { children: [_jsx(TagInput, {}), _jsx(TagList, {})] })] }));
}
